export var CLIENT_DEFAULT_DOLLAR_AMOUNT = 51.71485;
export var PLTV_URL = 'https://admissions.emeritus.org/purchase_event.json';
export var TIMEOUT_PLTV_FETCH = 12000;